import React from 'react';

import {Container} from 'containers/types';

import SearchFilter from 'components/Filters/SearchFilter';

interface SubNavigationProps {
  filters: any;
  setFilter: (field, value) => void;
}

class SubNavigation extends React.Component<Container & SubNavigationProps> {
  render() {
    return (
      <div className="colab-sidepadding-2 colab-centered">
        <SearchFilter
          value={this.props.filters.search}
          onChange={(search: string) => this.props.setFilter('search', search)}
        />
      </div>
    );
  }
}

export default SubNavigation;
